__turbopack_context__.v({
  "Hamburger": "Hamburger-module-scss-module__OfoTMG__Hamburger",
  "line": "Hamburger-module-scss-module__OfoTMG__line",
});
